import {
  DeleteOutlined,
  EyeOutlined,
  LoadingOutlined,
} from '@ant-design/icons';
import { Upload, Modal } from 'antd';
import {
  generateVideoThumbnail,
  getUrl,
  isImage,
  uploadMedia,
} from 'api/uploadMedia';
import { SVGIcon } from 'components/common/SVGIcons';
import { RestInputContext } from 'components/RestInput/RestInputContext';
import { get } from 'lodash';
import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { getImageUrl } from 'utils/tools';
import FormItem from '../FormItem';

function getBase64(img, callback) {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result));
  reader.readAsDataURL(img);
}

export default function FormUploadAvatar({
  source,
  defaultValue,
  previewSource,
  prefixSource,
  header,
  isFullWidth,
  ...props
}) {
  const [imageUrl, setImageUrl] = useState(defaultValue);
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const { form, record } = useContext(RestInputContext);
  const { t } = useTranslation();

  const uploadButton = (
    <div>
      {loading ? (
        <LoadingOutlined />
      ) : (
        <SVGIcon style={{ opacity: 0.5 }} name="addImage" />
      )}
      <div style={{ marginTop: 8, opacity: 0.5 }}>
        {t(header||'button.upload')}
      </div>
    </div>
  );

  const deleteImage = (e) => {
    e.stopPropagation();
    setImageUrl('');
    form.setFieldsValue({
      [source]: '',
    });
  };

  const customRequest = async ({ onSuccess, file, resource }) => {
    const responseS3 = await getUrl(file.name, file.type, resource);
    const response = await uploadMedia(responseS3.uploadUrl, file);

    if (!isImage(file.name) && previewSource) {
      const previewImageFile = await generateVideoThumbnail(file);
      const previewImageFileResponseS3 = await getUrl(
        previewImageFile.name,
        previewImageFile.type,
        resource,
      );
      await uploadMedia(previewImageFileResponseS3.uploadUrl, previewImageFile);

      form.setFieldsValue({
        [prefixSource ? `${prefixSource}.${previewSource}` : previewSource]:
          previewImageFileResponseS3.name,
      });
    }
    if (response) {
      setImageUrl(responseS3.url);
      onSuccess(responseS3.name, file);
    }
  };

  const handleChange = (info) => {
    if (info.file.status === 'uploading') {
      setLoading(true);
      return;
    }
    if (info.file.status === 'done') {
      // Get this url from response in real world.
      // getBase64(info.file.originFileObj, imageUrl =>
      //   this.setState({
      //     imageUrl,
      //     loading: false,
      //   }),
      // );

      form.setFieldsValue({
        [source]: (info.file && info.file.response) || info.file.url,
      });
      getBase64(info.file.originFileObj, () => {
        setLoading(false);
      });
    }
  };

  const renderPreview = () =>(
    <img
      src={getImageUrl(imageUrl)}
      alt="avatar"
      style={{ width: '100%', height: '100%', objectFit: 'contain' }}
    />
  )
    // isImage(imageUrl) ? (
    //   <img
    //     src={getImageUrl(imageUrl)}
    //     alt="avatar"
    //     style={{ width: '100%', height: '100%', objectFit: 'contain' }}
    //   />
    // ) : (
    //   <video src={imageUrl} style={{ width: '40px' }}>
    //     <track kind="captions" />
    //   </video>
    // );

  useEffect(() => {
    if (get(record, source)) {
      form.setFieldsValue({
        [source]: get(record, source),
      });
      setImageUrl(get(record, source));
    }
    if (
      get(
        record,
        prefixSource ? `${prefixSource}.${previewSource}` : previewSource,
      )
    ) {
      form.setFieldsValue({
        [prefixSource ? `${prefixSource}.${previewSource}` : previewSource]:
          get(
            record,
            prefixSource ? `${prefixSource}.${previewSource}` : previewSource,
          ),
      });
    }
  }, [prefixSource, previewSource, record, source, form]);

  return (
    <FormAvatarWrapper isFullWidth={isFullWidth}>
      <Modal open={visible} footer={null} onCancel={() => setVisible(false)}>
        <img
          alt="example"
          style={{ width: '100%' }}
          src={getImageUrl(imageUrl)}
        />
      </Modal>
      <FormItem source={source} defaultValue={defaultValue} {...props} noStyle>
        <input className="d-none" />
      </FormItem>
      {!!previewSource && (
        <FormItem
          {...props}
          noStyle
          source={
            prefixSource ? `${prefixSource}.${previewSource}` : previewSource
          }
        >
          <input className="d-none" />
        </FormItem>
      )}
      <FormItem {...props}>
        <Upload
          name="avatar"
          listType="picture-card"
          className="avatar-uploader"
          showUploadList={false}
          customRequest={customRequest}
          onChange={handleChange}
        >
          {imageUrl ? (
            <div className="img-wrapper">
              {renderPreview()}
              <div className="overlay">
                <EyeOutlined
                  onClick={(e) => {
                    e.stopPropagation();
                    setVisible(true);
                  }}
                />
                <DeleteOutlined onClick={deleteImage} />
              </div>
            </div>
          ) : (
            uploadButton
          )}
        </Upload>
      </FormItem>
    </FormAvatarWrapper>
  );
}

const FormAvatarWrapper = styled.div`
    .ant-upload {
      width: ${({isFullWidth})=>isFullWidth?'100%':'auto'} !important;
    }
  .img-wrapper {
    position: relative;
    height: 100%;
    width: 100%;

    .overlay {
      position: absolute;
      top: 0px;
      left: 0px;
      right: 5px;
      bottom: 0px;
      width: 100px;
      height: 100px;
      display: flex;
      z-index: 2;
      align-items: center;
      justify-content: center;
      border-radius: 4px;
      background: rgba(0, 0, 0, 0.3);
      visibility: hidden;
      &:hover {
        visibility: visible;
        & ~ .lbSetDefault {
          visibility: visible;
        }
      }
      .anticon {
        color: #fff;
        font-size: 24px;
        margin: 5px;
      }
    }

    &:hover {
      .overlay {
        visibility: visible;
      }
    }
    img:hover ~ .overlay {
      visibility: visible;
    }
  }
`;
